import { render, staticRenderFns } from "./select_organ_dialog.vue?vue&type=template&id=37b965bc"
import script from "./select_organ_dialog.vue?vue&type=script&lang=js"
export * from "./select_organ_dialog.vue?vue&type=script&lang=js"
import style0 from "./select_organ_dialog.vue?vue&type=style&index=0&id=37b965bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports